import classNames from 'classnames'
import { DetailedHTMLProps, ReactNode, TextareaHTMLAttributes } from 'react'
import TextArea from 'shared/components/elements/text-area'

import BaseLabel, { BaseLabelProps } from './BaseLabel'

export type TextAreaPropType = DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> & {
  label?: ReactNode
  labelProps?: BaseLabelProps
  inputClassName?: string
}

const BaseTextArea = (props: TextAreaPropType) => {
  const { label, labelProps, className, inputClassName, ...restProps } = props
  return (
    <div className={classNames(className || '', 'w-full')}>
      {label && <BaseLabel {...labelProps}>{label}</BaseLabel>}
      <TextArea
        placeholder="توضیحات"
        className={classNames(
          'border-1 rounded-lg border-gray-light',
          'focus:ring-transparent focus:border-gray-medium hover:border-gray-medium',
          'w-full  block caret-gray-500  resize-none',
          inputClassName
        )}
        {...restProps}
      />
    </div>
  )
}

export default BaseTextArea
